export const Events = [
	{
		id: "bugs-n-brews",
		title: "Bugs 'N' Brews",
		type: "Event",
		route: "Events",
		images: [
			require("../Photos/Bugs and Brews/upslope.jpeg"),
			require("../Photos/Bugs and Brews/upslope-2.jpeg"),
			require("../Photos/Bugs and Brews/bandbeer.jpg"),
			require("../Photos/Bugs and Brews/beer.jpg"),
			require("../Photos/Bugs and Brews/odd-13.jpeg"),
			require("../Photos/Bugs and Brews/upslope-3.jpeg"),
		],
		about:
			"Have you been considering tying flies? With our Bugs ‘n Brews events you can learn the skills needed to compose your own flies with expert guidance from our staff. We gather at local breweries, pubs, and restaurants alike making it a super easy going and fun learning environment. We choose a series of flies ranging from basic to more complex, and all skill levels are welcome at these events! The end of the evening brings a loosely judged competition where prizes are awarded for Best, Worst, and anything in between. We supply all the tying materials and tools necessary to get those who attend twisting up flies. Your first pint is on us, so come on by and see what it’s all about! Look for a Bugs-N-Brews at a brewery close to you. FREE.",
	},
	{
		id: "creek-cleanup",
		title: "Creek CleanUp",
		type: "Event",
		route: "Events",
		about:
			"Interested in giving back??  Join us for a Creek Clean Up.  One of the best ways to give back is to join the RMA crew for a stream clean up along our most local water, Boulder Creek.  Throughout the year we organize small and large groups for several Creek Clean Ups along the Creek.  Each year we pull more than 50 cubic yards of trash and debris from the creek habitat and her waters.  Whether it is through town, or up in the canyon along hwy 119; Boulder Creek experiences quite a bit of use throughout the year. On one of our stream clean ups we choose a section in need of love and spend a couple of hours picking up trash and debris.  We supply gloves and bags and tongs; but please dress appropriately for spending time in and around the creek picking up trash.  The event usually ends with a meet up back at the shop and some sort of picnic or BBQ depending upon attendance and seasonality.  These Creek Clean Ups are appropriate for all ages and are very family friendly.  Come join the fun at our next Creek Clean Up.  Please check the calendar for upcoming Creek Clean Ups or call the shop for the latest.",
		images: [
			require("../Photos/CCU/IMG_4555.jpg"),
			require("../Photos/CCU/IMG_4587.jpg"),
			require("../Photos/CCU/IMG_4584.jpg"),
			require("../Photos/CCU/Food.jpg"),
			require("../Photos/CCU/IMG_4563.jpg"),
			require("../Photos/CCU/IMG_4579.jpg"),
			require("../Photos/CCU/CreekCleanup-1.jpg"),
			require("../Photos/CCU/CreekCleanup-2.jpg"),
			require("../Photos/CCU/CreekCleanup-3.jpg"),
			require("../Photos/CCU/CreekCleanup-5.jpg"),
		],
	},
	{
		id: "fish-alongs",
		title: "Fish Alongs",
		type: "Event",
		route: "Events",
		about:
			"Come fishing with the Rocky Mountain Anglers family and crew. During the shoulder months when the shop slows a little we organize meet ups to fish hot spots throughout the Fall and winter. A standard day for the fish-alongs starts at the fly shop to grab last minute flies/tackle etc. We then car pool or caravan to the river or destination usually 1-2 hours away. Destinations include but not limited to: South Platte, Blue, Eagle, Arkansas, Colorado, St.Vrain, Big Thompson, South Boulder Creek, and Boulder Creek. Fish-alongs are a great way to learn waters you are not familiar with, as well as where it might be overperforming; and you may even come out of it with a new buddy to fish with. Early afternoon we get the grill fired up to share a “pot luck” style lunch and see how the day shaped up for everyone. Side note: you have not lived until you’ve had a hot dog topped with coleslaw and all the fixin’s. Come share a cold beer and a warm brat with the RMA family and crew at one of our Fish-A-Longs. FREE…..but bring something to share and to sip on.",
		images: [
			require("../Photos/Fish Alongs/Pueblo_18.jpg"),
			require("../Photos/Fish Alongs/Pueblo_01.jpg"),
			require("../Photos/Fish Alongs/IMG_1701.jpg"),
			require("../Photos/Fish Alongs/jakeyampa.jpg"),
			require("../Photos/Fish Alongs/Bearedman.jpg"),
			require("../Photos/fish photos/IMG_2648.jpg"),
		],
	},
	{
		id: "other-events",
		title: "Other Events",
		type: "Event",
		route: "Events",
		about: "",
		images: [
			require("../Photos/CCU/IMG_4587.jpg"),
			require("../Photos/CCU/IMG_4584.jpg"),
		],
	},
	{
		id: "intro",
		title: "FREE Intro to Fly Fishing",
		type: "Class",
		route: "Classes",
		about:
			"With our intro to fly fishing course, we look to give beginning anglers all the tools they need to catch fish independently with a fly rod. We split the class into three sections: knots and rigging, casting, and Q&A/gear/general knowledge. After this two to three-hour course, beginners will learn how to set up and rig their own fly rod and reel, become proficient at the basics of casting, and learn some basic stream entomology and knowledge on how to approach trout in a stream. If you’re feeling overwhelmed by the mountain of information there is to learn when starting out fly fishing, this class is a perfect way to distill things down and make fly fishing more approachable, leading to more fish caught and better times on the water. We consider ourselves the most beginner-friendly fly shop on the planet, and taking this course is sure to show you why!",
		images: [require("../Photos/intro.jpg")],
	},
	{
		id: "one-on-one",
		title: "One-On-One",
		type: "Class",
		route: "Classes",
		about:
			"Sometimes an angler will have a bit of trouble with one aspect of the game in particular, say mending, or a particular cast. For these customized situations we offer a variety of ONE to ONE classes and instruction opportunities.  This platform of One-On-One classes is designed to help anglers problem solve, or tackle a particular issue.  We offer: casting, fly tying, nymphing, knots, euro nymphing, roll casting, spey casting, tenkara fishing, and many more.  These classes take place in the classroom or outside the shop at a park or field suitable for casting. If you are interested in a One-On-One class call the shop to pick a date and time and the first session is free.  After that the classes are billed at a rate of $40/ hour.  Many anglers realize the help they need within the first session, but often come back for a tune ups or to help knock off some rust.",
		prices: ["$40 per hour"],
		images: [],
	},
	{
		id: "tying-classes",
		title: "Tying Classes",
		type: "Class",
		route: "Classes",
		about:
			"For thousands of years, fishermen have used feathers and furs of wild game to create artificial flies. Binding various materials to a hook, in order to entice fish to strike, has evolved into an art form that has been embraced by the fly fishing community. Selecting the right hooks, choosing alluring threads and feathers, and building durable and effective flies is what captivates anglers and kindles their passion for fly fishing. So let Rocky Mountain Anglers inspire you and help you continue the time-honored tradition of fly tying, by signing up for private fly tying lessons!",
		images: [
			require("../Photos/tying/TyingClasses-1.jpg"),
			require("../Photos/tying/TyingClasses-2.jpg"),
			require("../Photos/tying/tying.jpg"),
			require("../Photos/Bugs and Brews/tyingstones.jpg"),
		],
	},
	{
		id: "kids-camps",
		title: "Summer Camp",
		type: "Camp",
		route: "Camp",
		prices: [
			{
				title: "Price:",
				price: "$650.00 ($300 deposit)",
				ages: "9-14",
				time: "8:30am - 3:30pm.",
				days: "Tuesday, Wednesday, Thursday",
				description: "",
			},
		],
		about:
			"RMA’s fly Fishing Summer Camps are amazing day camps for young fly anglers. Some campers come to us with experience, but it is not required, and often it is the passion for fishing and the outdoors that can make this camp special. We spend time on a variety of water including lakes, ponds, and streams like Boulder Creek or the Big Thompson in Rocky Mountain National Park. We fish for trout as well as warm-water species, and each session spends a day on the private water of Sylvandale Ranch outside Loveland. All fishing equipment is included and can be provided, but many youngsters show up with their own kit ready to go. We like a 3 to 1 ratio of campers to guides/counselors. Other activities include fly tying, casting practice, and bug collecting, but most of the day is spent on the water.",
		images: [
			require("../Photos/Kids Camp/IMG_8990.jpg"),
			require("../Photos/Kids Camp/IMG_0375.jpg"),
			require("../Photos/Kids Camp/IMG_4414.jpg"),
			require("../Photos/Kids Camp/IMG_4351.jpg"),
			require("../Photos/Kids Camp/IMG_1462.jpg"),
			require("../Photos/Kids Camp/IMG_0737.jpg"),
			require("../Photos/Kids Camp/IMG_1640.jpg"),
			require("../Photos/Kids Camp/IMG_1626.jpg"),
			require("../Photos/Kids Camp/IMG_1634.jpg"),
			require("../Photos/Kids Camp/erikkidscamp.jpg"),
			require("../Photos/Kids Camp/IMG_0057.jpg"),
			require("../Photos/Kids Camp/IMG_0079.jpg"),
		],
	},
	{
		id: "other-classes",
		title: "Other Classes",
		type: "Class",
		route: "Classes",
		about: "",
		images: [
			require("../Photos/OtherClasses/OtherClasses-5.jpg"),
			require("../Photos/OtherClasses/OtherClasses-6.jpg"),
			require("../Photos/OtherClasses/OtherClasses-4.jpg"),
		],
	},
];
